import { LoggedGuard } from '../guards/LoggedGuard'
import { adminRoutes } from './adminRoutes'
import { commonRoutes } from './commonRoutes'

export const loggedRoutes = {
    path: '/',
    element: <LoggedGuard />,
    children: [commonRoutes, adminRoutes],
}
